const duplicateEmailPattern = /(?:email.*(?:unique|already exists|already in use))|(?:expected.*email.*unique)/i;

export function getUserSubmitError(error, {create, mode}) {
  const subject = mode === 'staff' ? 'staff member' : 'user';
  const action = create ? 'create' : 'update';
  const errors = Array.isArray(error?.errorArray) ? error.errorArray : [];
  const duplicateEmail = error?.code === 'EMAIL_ALREADY_EXISTS' ||
    errors.some(message => duplicateEmailPattern.test(message));

  if (duplicateEmail) {
    return {
      title: 'Email already in use',
      messages: ['A user with this email address already exists. Use a different email address or update the existing user.'],
      fieldError: 'This email address is already in use.'
    };
  }

  return {
    title: `Unable to ${action} ${subject}`,
    messages: errors.length > 0
      ? errors
      : ['Please try again. If the problem continues, contact support.']
  };
}

export function getUserSuccessMessage({create, mode}) {
  const subject = mode === 'staff' ? 'Staff member' : 'User';
  return `${subject} ${create ? 'created' : 'updated'} successfully.`;
}
